import * as moment from 'moment';
import { FormEvent, useState } from 'react';
import { Alert, Button, FormControl } from 'react-bootstrap';
import { IBloodDrawConfirmationContract } from '@nkr/models/index';
import { styles } from './styles';

interface IProps {
    item: IBloodDrawConfirmationContract,
    onConfirm: (contract: IBloodDrawConfirmationContract) => void
}

const ConfirmBloodDrawCompletionRow = (props: IProps) => {
    const [rescheduling, setRescheduling] = useState(false);
    const [newDrawDate, setNewDrawDate] = useState('');

    // A missed draw is rescheduled to today or any later weekday - deliberately not the 5-7-days-before-surgery
    // rule the scheduled-date alert applies, because by now surgery may be less than 5 days away. Today counts:
    // "no, it did not happen yesterday, it is happening today" is the common answer.
    const minDate = moment().format('YYYY-MM-DD');

    const draw = moment(newDrawDate, 'YYYY-MM-DD', true);
    const isWeekend = draw.day() === 0 || draw.day() === 6;
    const isTodayOrLater = draw.isValid() && draw.isSameOrAfter(moment().startOf('day'));
    const isValid = isTodayOrLater && !isWeekend;

    const handleNewDrawDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        setNewDrawDate(e.currentTarget.value);
    };

    const handleYes = () => {
        props.onConfirm({ ...props.item, bloodDrawCompleted: true });
    };

    const handleNo = () => {
        setRescheduling(true);
    };

    const handleSaveNewDate = () => {
        props.onConfirm({ ...props.item, bloodDrawCompleted: false, scheduledBloodDrawDate: newDrawDate });
    };

    return (
        <tr>
            <td>{props.item.swapNumber}</td>
            <td>
                {props.item.donorCenterAlias}
                {props.item.rdnCenterId > 0 && <> (<span style={styles.rdnCenterAlias}>{props.item.rdnCenterAlias}</span>)</>}
            </td>
            <td>{props.item.donorAlias}</td>
            <td>{props.item.recipientCenterAlias}</td>
            <td>{props.item.recipientAlias}</td>
            <td>{moment(props.item.targetSurgeryDate).format('M/D/YYYY')}</td>
            <td>{moment(props.item.scheduledBloodDrawDate).format('M/D/YYYY')}</td>
            <td>
                {rescheduling ?
                    <>
                        <div style={styles.rescheduleWell}>
                            <FormControl
                                type='date'
                                value={newDrawDate}
                                min={minDate}
                                onChange={handleNewDrawDateChange}
                            />
                            <Button bsStyle='primary' bsSize='xs' disabled={!isValid} onClick={handleSaveNewDate}>
                                Save
                            </Button>
                        </div>
                        <Alert hidden={isValid} bsStyle='warning' style={styles.validationAlert}>
                            {isTodayOrLater && isWeekend
                                ? 'Blood draw cannot fall on a weekend.'
                                : 'Enter the new scheduled blood draw date. It cannot be in the past.'}
                        </Alert>
                    </>
                    :
                    <>
                        <Button bsStyle='primary' bsSize='xs' style={styles.answerButton} onClick={handleYes}>
                            Yes
                        </Button>
                        <Button bsStyle='default' bsSize='xs' onClick={handleNo}>
                            No
                        </Button>
                    </>
                }
            </td>
        </tr>
    );
};

export default ConfirmBloodDrawCompletionRow;
